<template>
  <div>
    <v-container>
      <warning />
      
      <roles-table />

      <add-button />
    </v-container>
  </div>
</template>

<script>
import RolesTable from './RolesTable';
import AddButton from './AddButton';
import Warning from './Warning';
import { mapActions } from 'vuex';

export default {
  components: { RolesTable, Warning, AddButton },
  methods: {
    ...mapActions('roles', ['getRoles', 'getPermissions']),
    ...mapActions('whizeosupportToolsStore', ['SHOW_SNACKBAR']),
  },
  async mounted() {
    const rolesPromise = this.getRoles();
    const permissionsPromise = this.getPermissions();
    
    Promise.all([ rolesPromise, permissionsPromise ])
    .catch(() => {
      const errorMessage = {
        visible: true,
        color: 'error',
        message: `Couldn't fetch roles and permissions from API.`
      };
      this.SHOW_SNACKBAR(errorMessage);
    });
  }
}
</script>
